module.exports = __webpack_public_path__ + "img/door-contact-lg-open.9af2db51.svg";